import { Box, Button, CssBaseline, Typography } from '@mui/material';

import getCDNImagePath from '../../Utils/getCDNImagePath';

export default function ErrorPage() {
    return (
        <Box
            sx={{
                alignItems: 'center',
                backgroundColor: '#edf2f6',
                display: 'flex',
                flexDirection: 'column',
                height: '100dvh',
                justifyContent: 'center',
                px: 1,
                textAlign: 'center',
            }}
        >
            <CssBaseline />
            <img
                alt="RenkiAuth"
                src={getCDNImagePath('renki/renkilogo_text_auth.png')}
                style={{ height: 90, marginBottom: 40 }}
            />
            <Typography gutterBottom variant="h4">
                Oops! Something went wrong.
            </Typography>
            <Typography gutterBottom variant="body1">
                We are sorry, but we could not process your request at the moment. Please try again later.
            </Typography>
            <Typography gutterBottom variant="body1">
                Here are some steps you can take:
            </Typography>
            <Box sx={{ textAlign: 'start' }}>
                <ul>
                    <li>Check your internet connection and try again.</li>
                    <li>Refresh the page and try again.</li>
                    <li>If the problem persists, please contact support for assistance.</li>
                </ul>
            </Box>
            <Box>
                <Typography gutterBottom variant="body1">
                    If you need further assistance, please contact our support:
                </Typography>
                <Typography gutterBottom variant="body1">
                    Email: contact-us@missing-link.fi
                </Typography>
                <Typography gutterBottom variant="body1">
                    Phone: +358 505576771
                </Typography>
            </Box>
            <Box
                sx={{
                    mt: 2,
                }}
            >
                <Button color="primary" onClick={() => (window.location.href = '/')} variant="contained">
                    Go to Home Page
                </Button>
            </Box>
        </Box>
    );
}
